/* eslint react-hooks/exhaustive-deps: 0 */
import { useEffect, useState } from 'react';
import moment from 'moment';
import {
  Grid,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { CatchingPokemonSharp } from '@mui/icons-material';

const getTimezoneOffset = value => value.getTimezoneOffset() * 60000;
const localToUTC = dateTime => {
  const utcFromLocal = new Date(dateTime.getTime() - getTimezoneOffset(dateTime));
  return utcFromLocal;
};


export const DeliveryField = (props) => {
  const { onChange, product } = props
  if (!product.deliveryStart) {
    delete product.deliveryStart
  }

  const [ deliveryStart, setDeliveryStart ] = useState(moment(product.deliveryStart * 1000).isValid() ? moment(product.deliveryStart * 1000) : null)
  const [ deliveryEnd, setDeliveryEnd ] = useState(moment(product.deliveryEndDate * 1000).isValid() && product.deliveryEndDate > product.deliveryStart ? moment(product.deliveryEndDate * 1000) : null)
  const [ renderTime, setRenderTime ] = useState(new Date().getTime())

  const deliveryStartMinDate = moment().subtract(1, 'years').month(0)
  const deliveryStartMaxDate = deliveryEnd || moment().add(1, 'years').month(11)
  const deliveryEndMinDate = deliveryStart || moment().subtract(1, 'years').month(0)
  const deliveryEndMaxDate = moment().add(1, 'years').month(11)
  
  useEffect(() => {
    if (product.deliveryStart) {
      setDeliveryStart(moment(product.deliveryStart * 1000))
    }
    setDeliveryEnd(moment(product.deliveryEndDate * 1000).isValid() && product.deliveryEndDate > product.deliveryStart ? moment(product.deliveryEndDate * 1000) : null)
  }, [product])

  useEffect(() => {
    if (onChange) { 
      if (deliveryStart <= deliveryEnd || deliveryEnd === null) {
        onChange([deliveryStart, deliveryEnd])
      }
    }
  }, [deliveryStart, deliveryEnd])


  return (
    <Grid container spacing={1} sx={{ marginTop: 1 }}>
      <Grid item xs={6}>
        <DatePicker 
          views={['month', 'year']}
          value={deliveryStart}
          minDate={deliveryStartMinDate}
          maxDate={deliveryStartMaxDate}
          format="MMM YYYY"
          localeText={{
            fieldMonthPlaceholder: () => "MMM"
          }}
          onChange={(newDate) => {
            setDeliveryStart(moment(newDate).date(1).hour(0).minute(0).second(0))
          }}
          slotProps={{
            textField: {
              error: false,
            },
          }}
          label={'Delivery Start'}
        />
      </Grid>
      <Grid item xs={6}>
        <DatePicker 
          views={['month', 'year']}
          value={deliveryEnd}
          minDate={deliveryEndMinDate}
          maxDate={deliveryEndMaxDate}
          format="MMM YYYY"
          localeText={{
            fieldMonthPlaceholder: () => "MMM"
          }}
          onChange={(newDate) => {
            setDeliveryEnd(moment(newDate).date(1).hour(0).minute(0).second(0).add(1, 'months').subtract(1, 'days'))
          }}
          slotProps={{
            textField: {
              error: false,
            },
          }}
          label={'Delivery End (Optional)'}
        />
      </Grid>
    </Grid>
  )
}